import { type FC, memo } from 'react';
import styles from './index.module.scss';
import logo from '@assets/images/header/parrot-logo.svg';
import pointIcon from '@assets/images/header/point-icon.svg';
import ConnectWallet from '@components/connect-wallet';
import MenuList from './menu-list';
import { menus } from 'src/routers/menu';
import { globalSettingModel } from '@models/global-setting.model';
import { useModel } from 'foca';
import { useSignCode } from '@hooks/use-sign-code';
import { Link } from 'react-router-dom';
// import { ExplorerSetting } from './explorer-setting';

const Header: FC = () => {
  useSignCode();
  const theme = useModel(globalSettingModel, (state) => state.theme);
  const $menus = menus.map((menu) => {
    return <MenuList menu={menu} key={menu.key} />;
  });

  return (
    <>
      <div className={`${styles.wrapper} ${theme === 'dark' ? styles.dark : ''}`}>
        <div className={styles.logo}>
          <img src={logo} alt="Parrot" title="Parrot" className={styles.logo_img} />
          <div className={styles.logo_text}>Parrot Finance</div>
        </div>
        <div className={styles.menus}>{$menus}</div>
        <div className={styles.right}>
          <Link to="/leaderboard" className={styles.point}>
            <img src={pointIcon} />
            <span>Points</span>
          </Link>
          <ConnectWallet />
          {/* <ExplorerSetting /> */}
        </div>
      </div>
    </>
  );
};

export default memo(Header);
